export enum Role {
  CompanyAdministrator = 'CompanyAdministrator',
  Administrator = 'Administrator',
  User = 'User',
}
